module.exports = __webpack_public_path__ + "img/Woven_Logo.1c26c455.png";